import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';

import { connect } from 'react-redux';
import DonorFullPage from '../Components/Donor/DonorFullPage';
import { dpath, videoType } from '../utils/shared';
import { donorsIncluded } from '../utils/donorHelpers';
// import ReactPlayer from 'react-player';
import { prepareSlides } from '../utils/slideshowHelpers';

const config = {
    donor_col: 3,
    donor_row: 8
}

const videoStyle = {
    preload: 'auto',
    position: 'fixed',
    minWidth: '100%',
    minHeight: '100%',
    width: '100vw',
    height: '100vh',
    zIndex: 0,
    loop: '',
    autoplay: "",
    muted: "",
    pointerEvents: "none"
}

const screen1Backdrop = {
    opacity: .8,
    backgroundColor: '#0019e6',
}

const screen2Backdrop = {
    opacity: .8,
    backgroundColor: '#0019e6',
}

class dc3x1 extends Component {

    constructor(props) {
        super(props);
        this._donors = null;
        this._categoryCurrent = -1;
        this._donorIndex = 0
        this._endOfDonorLoop = true;
        this._mainCategoryName = "";
        this._description = "";
        this._cycleInterval = null;

        this._cycleScreen1Seconds = null;
        this._cycleScreen2Seconds = null;
        this._cycleScreen3Seconds = null;

        this._cycleScreen3SecondsFull = null;

        this.state = {
            donorData: null,
            screen1: null,
            screen2: null,
            screen1Slide: 0,
            screen2Slide: 0,
            cycleIndex: 0
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
        this.initDonors();
        this.initScreens();

        this._cycleInterval = setInterval(() => {
            this.timedCycle();
        }, 1000);

        this.cycleDonorIndex(config.donor_col, config.donor_row);

    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    //for unique transition keys
    cycleIndex = () => {
        let cycleIndex = this.state.cycleIndex;
        if (cycleIndex === 100) {
            cycleIndex = 0;
        }
        this.setState({
            cycleIndex: ++cycleIndex
        })
    }

    initDonors = () => {

        let donorListModule = _.find(this.props.content.dm_active, { name: "Donors" });
        let includes = [];
        if (_.has(donorListModule, 'contents.include_categories')) {
            includes = donorListModule.contents.include_categories;
        }
        this._donors = donorsIncluded(this.props.donors.donorCategories, includes);
    }

    initScreens = () => {
        let screen1 = _.find(this.props.content.dm_active, { name: "Screen1" });
        screen1.contents = prepareSlides(screen1.contents);
        let screen2 = _.find(this.props.content.dm_active, { name: "Screen2" });
        screen2.contents = prepareSlides(screen2.contents);
        this.setState({
            screen1: screen1,
            screen2: screen2
        })
        let donor_module = _.find(this.props.content.dm_active, { name: "Donors" });

        this._cycleScreen1Seconds = screen1.contents.cycle_times[0];
        this._cycleScreen2Seconds = screen2.contents.cycle_times[0];
        this._cycleScreen3Seconds = donor_module.contents.cycle_time;
        this._cycleScreen3SecondsFull = this._cycleScreen3Seconds;
    }

    cycleDonorIndex = (columns, rows) => {

        if (this._endOfDonorLoop === true) {
            this._categoryCurrent++;
            this._donorIndex = 0;
            if (this._categoryCurrent === this._donors.length) {
                this._categoryCurrent = 0;
            }
        }

        let total = columns * rows;
        let start = this._donorIndex * total;
        let cat = this._donors[this._categoryCurrent];
        let parent = _.find(this.props.donors.donorCategories, { id: Number(cat.parent_category) });
        if (parent) {
            this._description = parent.description;
            this._mainCategoryName = parent.name;
        }

        if (!cat.donors[start]) {
            start = 0
            this._donorIndex = 0;
        }

        this._endOfDonorLoop = false;
        let end = start + (total);
        if (!cat.donors[end]) {
            end = cat.donors.length;
            this._endOfDonorLoop = true;
            this._donorIndex = 0;
        }
        else {
            this._donorIndex++
        }

        let donorsSliced = cat.donors.slice(start, end);
        let perColumn = 0;

        //distribute end page logic for empty units in last row
        if (this._endOfDonorLoop===true){
            let dLength = donorsSliced.length;
            let extraSpaces = 0; //default to 0
            perColumn = Math.ceil(dLength/columns);
            if (perColumn*columns>dLength){ //extra spaces on last row required
                extraSpaces=(perColumn*columns)-dLength;
            }  
            let normalSpaces = rows-perColumn //spaces to add on each normal row
            let lastSpaces = normalSpaces+extraSpaces //spaces to add on last row

            for (var i=0; i<columns; i++){
                if (i<(columns-1)){ //rows prior to last
                    for (var a=0; a<normalSpaces; a++){
                        donorsSliced.splice((i*rows)+perColumn, 0, {name: ""});
                    }
                }
                else{
                    for (var b=0; b<lastSpaces; b++){
                        donorsSliced.splice((i*rows)+perColumn, 0, {name: ""});
                    }
                }

            }

            // for (var i=0; i<columns; i++){
            //     let sp = 0
            //     let adder = 0;
            //     if (!evenDist){ //handle distributing last row
            //         adder = 1;
            //         if (extraDonors>0){
            //             sp=1
            //             extraDonors--;
            //             adder = 0;
            //         }
            //     }
            //     for (var a=0; a<spaces+adder; a++){
            //         donorsSliced.splice((i*rows)+perColumn+sp, 0, {name: ""});
            //     }
            // }
        }

        //distribute end page logic for even distribution
        // if (this._endOfDonorLoop===true){
        //     let dLength = donorsSliced.length;

        //     perColumn = Math.floor(dLength/columns);
        //     let extraDonors = dLength //default to number
        //     let evenDist = false;
        //     if (dLength>=columns){ //if equal or greater then one row, modulo
        //         extraDonors = dLength%columns;
        //     }
        //     if (extraDonors===0){
        //         evenDist=true;
        //     }
               
        //     let spaces = Math.floor((total-dLength)/columns)
        //     for (var i=0; i<columns; i++){
        //         let sp = 0
        //         let adder = 0;
        //         if (!evenDist){ //handle distributing last row
        //             adder = 1;
        //             if (extraDonors>0){
        //                 sp=1
        //                 extraDonors--;
        //                 adder = 0;
        //             }
        //         }
        //         for (var a=0; a<spaces+adder; a++){
        //             donorsSliced.splice((i*rows)+perColumn+sp, 0, {name: ""});
        //         }
        //     }
        // }

        this.cycleIndex();
        this.setState({
            donorData: {
                donors: donorsSliced,
                name: cat.name
            }
        })

    }

    timedCycle = () => {
        if (this._cycleScreen1Seconds) {
            this._cycleScreen1Seconds--;
            if (this._cycleScreen1Seconds === 0) {
                //cycle screen 1;
                this.cycleScreen1();
            }
        }
        if (this._cycleScreen2Seconds) {
            this._cycleScreen2Seconds--;
            if (this._cycleScreen2Seconds === 0) {
                //cycle screen 1;
                this.cycleScreen2();
            }
        }
        if (this._cycleScreen3Seconds) {
            this._cycleScreen3Seconds--;
            if (this._cycleScreen3Seconds === 0) {
                this._cycleScreen3Seconds = this._cycleScreen3SecondsFull;
                this.cycleDonorIndex(config.donor_col, config.donor_row);
            }
        }
    }

    cycleScreen1 = () => {
        let screen1Slide = this.state.screen1Slide;
        if (screen1Slide < this.state.screen1.contents.images.length - 1) {
            screen1Slide++;
        }
        else {
            screen1Slide = 0;
        }
        this.setState({
            screen1Slide: screen1Slide
        })
        this._cycleScreen1Seconds = this.state.screen1.contents.cycle_times[screen1Slide];
    }

    cycleScreen2 = () => {
        let screen2Slide = this.state.screen2Slide;
        if (screen2Slide < this.state.screen2.contents.images.length - 1) {
            screen2Slide++;
        }
        else {
            screen2Slide = 0;
        }
        this.setState({
            screen2Slide: screen2Slide
        })
        this._cycleScreen2Seconds = this.state.screen2.contents.cycle_times[screen2Slide];
    }

    handleKeyDown = (e) => {
        switch (e.key) {
            case 'd':
                console.log(this.props);
                break;
            case '1':
                this.cycleScreen1();
                break;
            case '2':
                this.cycleScreen2();
                break;
            case '3':
                this.cycleDonorIndex(config.donor_col, config.donor_row);
                break;
            default:
                break;
        }
    }

    renderWhitePanel = () => {
        if (this.state.renderWhite === true) {
            return (
                <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.sv.width, height: this.props.screen.sv.height - (config.topBarHeight * this.props.screen.sv.height), opacity: config.panelOpacity, backgroundColor: 'white' }} />
            )
        }
        else {
            return (
                <span />
            )
        }
    }

    render() {

        if (!this.state.screen1 || !this.state.screen2 || !this.state.donorData) {
            return null;
        }
        let sDims = {
            height: this.props.screen.sv.height,//1080,
            width: this.props.screen.sv.width / 3//1920
        }
        //console.log(this.props.block.screens[0].height, this.props.screen.sv.height)
        let modifier = .6;
        sDims.fsTitle = sDims.height * 0.05556 * modifier;
        sDims.fsTitleSub = sDims.height * 0.05556 * modifier;
        if (this.props.content.settings.custom_vars) {
            if (this.props.content.settings.custom_vars.ParentGroupFontSize) {
                sDims.fsTitle = sDims.height * this.props.content.settings.custom_vars.ParentGroupFontSize*.01;
            }
            if (this.props.content.settings.custom_vars.GroupFontSize) {
                sDims.fsTitleSub = sDims.height *this.props.content.settings.custom_vars.GroupFontSize*.01;
            }
        }


        sDims.fsSubheader = sDims.height * 0.03333 * modifier;
        sDims.fsNames = sDims.height * 0.04444 * modifier;
        sDims.yOffsetTitle = sDims.height * .05;
        sDims.yOffsetSubheader = sDims.height * .1;
        sDims.yOffsetSubheaderUnderline = sDims.height * .13;
        sDims.yOffsetNames = sDims.height * .16;
        let videoSource = dpath(this.props.screen.mode, this.props.content.settings.lower_layer_file.path, this.props.content.settings.lower_layer_file.file_name, this.props.screen.webkey);
        let vType = videoType(this.props.content.settings.lower_layer_file.file_name);

        return (
            <div className="futura-book" style={{ color: 'white' }}>

                {/* Background Video */}
                { vType ? 
                <div style={{ zIndex: -90, pointerEvents: "none", position: 'absolute', left: 0, top: 0, opacity: 1, width: this.props.screen.sv.width, height: this.props.screen.sv.height }}>
                    <video className="nodrag" style={videoStyle} id="background-video" loop autoPlay muted>
                        <source src={videoSource} type={vType} />
                        Your browser does not support the video tag.
                        </video>
                </div>
                : <span />
                }

                {/* Screen 1 Backdrop */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.screen1.contents.empty_slides[this.state.screen1Slide]} >
                        {this.state.screen1.contents.empty_slides[this.state.screen1Slide] ?
                            <div />
                            :
                            <div style={{ backgroundColor: screen1Backdrop.backgroundColor, opacity: screen1Backdrop.opacity, position: 'absolute', left: 0, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height }} />
                        }
                    </div>
                </CSSTransitionGroup>

                {/* Screen 1 Slides */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.screen1Slide} >
                        <div style={{ position: 'absolute', left: 0, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height }}>
                            <img alt="Screen 1 Slide" style={{ width: '100%', height: '100%' }} src={dpath(this.props.screen.mode, this.state.screen1.contents.images[this.state.screen1Slide].path, this.state.screen1.contents.images[this.state.screen1Slide].file_name, this.props.screen.webkey)} />
                        </div>
                    </div>
                </CSSTransitionGroup>

                {/* Screen 2 Backdrop */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.screen2.contents.empty_slides[this.state.screen2Slide]} >
                        {this.state.screen2.contents.empty_slides[this.state.screen2Slide] ?
                            <div />
                            :
                            <div style={{ backgroundColor: screen2Backdrop.backgroundColor, opacity: screen2Backdrop.opacity, position: 'absolute', left: this.props.screen.sv.width / 3, top: 0, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height }} />
                        }
                    </div>
                </CSSTransitionGroup>

                {/* Screen 2 Slides */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.screen2Slide} >
                        <div style={{ position: 'absolute', left: this.props.screen.sv.width / 3, top: 0, opacity: 1, width: this.props.screen.sv.width / 3, height: this.props.screen.sv.height }}>
                            <img alt="Screen 2 Slide" style={{ width: '100%', height: '100%' }} src={dpath(this.props.screen.mode, this.state.screen2.contents.images[this.state.screen2Slide].path, this.state.screen2.contents.images[this.state.screen2Slide].file_name, this.props.screen.webkey)} />
                        </div>
                    </div>
                </CSSTransitionGroup>

                {/* Blue Backdrop */}
                <div style={{ position: 'absolute', left: sDims.width * 2, top: 0, opacity: .8, backgroundColor: '#0019e6', width: sDims.width, height: sDims.height }} />

                {/* Group Description Underline*/}
                <div style={{ position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetSubheaderUnderline, backgroundColor: 'white', opacity: 1, width: sDims.width * .9, height: sDims.height * .0025 }} />

                {/* Group Name Section Name */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this._mainCategoryName + " " + this.state.donorData.name} >
                        {/* Group Name Section Name */}
                        <div className="futura-bold" style={{ position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetTitle, width: sDims.width * .9, height: sDims.height * .05 }}>
                            {this.state.donorData && this.state.donorData.name ? <span><span style={{fontSize: sDims.fsTitle}}>{this._mainCategoryName}</span><span style={{fontSize: sDims.fsTitleSub}}>{" "+this.state.donorData.name}</span></span> : <span />}
                        </div>
                    </div>
                </CSSTransitionGroup>

                {/* Group Description */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this._description} >
                        {/* Group Description */}
                        <div style={{ fontSize: sDims.fsSubheader, position: 'absolute', left: sDims.width * 2.05, top: sDims.yOffsetSubheader, opacity: 1, width: sDims.width * .9, height: sDims.height * .05 }}>
                            {this._description ? <span>{this._description}</span> : <span />}
                        </div>
                    </div>
                </CSSTransitionGroup>

                {/* Donor name lists */}
                <CSSTransitionGroup
                    component='div'
                    transitionName='slowfade'
                    transitionEnterTimeout={0}
                    transitionLeaveTimeout={0}>
                    <div key={this.state.cycleIndex} >
                        <div style={{ position: 'absolute', left: sDims.width * 2, top: 0, opacity: 1, width: sDims.width, height: sDims.height }}>

                            {/* Donor Names*/}
                            <div style={{ position: 'absolute', left: sDims.width * .05, top: sDims.yOffsetNames, width: sDims.width * .9, height: sDims.height * .8 }}>

                                {this.state.donorData ? <DonorFullPage
                                    fontclass={"legacysans-book"}
                                    height={sDims.height * .8}
                                    width={sDims.width * .9}
                                    rows={config.donor_row}
                                    columns={config.donor_col}
                                    donorData={this.state.donorData.donors}
                                    screen={this.props.screen}
                                    sort="column"
                                    overrideFontSize={sDims.fsNames}
                                    overrideMarginRight={sDims.width*.0375}
                                /> : <span />}
                            </div>
                            <span style={{right: sDims.width * .05, position: 'absolute', width: '100%', textAlign: 'right', bottom: this.props.screen.sv.height*.055, fontSize: sDims.fsNames*.5}}>
                            {(this.props.content.settings.custom_vars && this.props.content.settings.custom_vars.barnabasdeceased)?this.props.content.settings.custom_vars.barnabasdeceased:<span>* Deceased</span>}
                                </span>
                        </div>                     
                    </div>
                </CSSTransitionGroup>
            </div>

        );
    }



}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        donors: state.donors,
        screen: state.screen,
        block: state.content.settings.display_blocks[0]
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(dc3x1);


// WEBPACK FOOTER //
// ./src/containers/dc3x1.js